const ApiService = Shopware.Classes.ApiService;

/**
 * @class
 * @extends ApiService
 */
class TrustpilotApiService extends ApiService {
    /**
     * @constructor
     * @param {AxiosInstance} httpClient
     * @param loginService
     * @param context
     * @param apiEndpoint
     */
    constructor(httpClient, loginService, context, apiEndpoint = 'ecocode/trustpilot') {
        super(httpClient, loginService, apiEndpoint);
        this.context = context;
        this.name = 'trustpilotService';
    }

    overview() {
        return this.httpClient
            .get(
                `/_info/${this.getApiBasePath()}/overview`,
                {
                    headers: this.getBasicHeaders(),
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }
}

export default TrustpilotApiService;
